import { useLocation, Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { MySpinner } from "components/MySpinner";
import useQuery from "utils/useQuery";
import { useEffect, useState } from "react";
import { Pagination } from "components/Pagination";
import { SendingPriceListHistoryTable } from "features/SendingPriceListHistory/SendingPriceListHistoryTable";
import { getSendingPriceListHistory } from "services/api";

export const SendingPriceListHistoryPage = () => {
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const [items, setItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    query.get("page") ? Number(query.get("page")) : 1
  );
  const getPageSize = localStorage.getItem("pageSize") ? JSON.parse(localStorage.getItem("pageSize")) : {};
  const [pageSize, setPageSize] = useState(getPageSize[pathname] || 10);

  const fetchHistory = () => {
    getSendingPriceListHistory({
      count: pageSize,
      offset: (currentPage - 1) * pageSize,
      by: "date",
      dir: "DESC",
    })
      .then((res) => {
        setItems(res.items ?? []);
        setTotalItems(res.totalItems ?? 0);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    fetchHistory();
  }, [currentPage, pageSize]);

  return (
    <Container fluid className="p-0 sending-price-list-history">
      {loading && <MySpinner overlay />}
      <Card className="mb-0 filter">
        <CardBody>
          <h1 className="h3 mb-3">История рассылок прайс листов</h1>

          <Row>
            <Col md="2">
              <Link
                to="/sales/sendingPriceList"
                color="primary"
                className="button-wide btn btn-outline-primary"
              >
                ← К рассылкам прайс листов
              </Link>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div>
        <SendingPriceListHistoryTable items={items} />

        <Card>
          <CardBody>
            <Pagination
              totalCount={totalItems}
              currentPage={currentPage}
              pageSize={pageSize}
              setCurrentPage={setCurrentPage}
              onChangePageSize={setPageSize}
            />
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};
